import { useState, useEffect, useMemo } from "react";
import { api, type AuditLog } from "@/lib/api";

export default function AuditoriaPage() {
  const [logs, setLogs] = useState<AuditLog[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.getAuditLogs().then(setLogs).catch(() => setLogs([])).finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    if (!search) return logs;
    const s = search.toLowerCase();
    return logs.filter((l) =>
      l.action.toLowerCase().includes(s) || l.details.toLowerCase().includes(s) || l.user_name.toLowerCase().includes(s)
    );
  }, [logs, search]);

  const exportCsv = () => {
    const header = "fecha,usuario,accion,entidad,detalle\n";
    const rows = filtered.map((l) =>
      `"${l.created_at}","${l.user_name}","${l.action}","${l.entity_type}","${l.details.replace(/"/g, '""')}"`
    ).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `auditoria-ksm-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start flex-wrap gap-4">
        <div>
          <h1 className="text-2xl font-bold">Auditoría</h1>
          <p className="text-sm text-[var(--color-text-muted)]">Bitácora completa del sistema</p>
        </div>
        <button onClick={exportCsv} className="btn-secondary text-sm cursor-pointer"><i className="ri-download-line"></i> Exportar CSV</button>
      </div>
      <div className="card">
        <input className="input-field" placeholder="Buscar acción, usuario o detalle..." value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>
      {loading ? (
        <div className="text-center py-12"><i className="ri-loader-4-line animate-spin text-2xl"></i></div>
      ) : (
        <div className="card overflow-x-auto max-h-[70vh] overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-[var(--color-bg-card)]">
              <tr className="text-left text-[var(--color-text-muted)] border-b border-[var(--color-border)]">
                <th className="pb-3 pr-4">Fecha</th>
                <th className="pb-3 pr-4">Usuario</th>
                <th className="pb-3 pr-4">Acción</th>
                <th className="pb-3 pr-4">Entidad</th>
                <th className="pb-3">Detalle</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((l) => (
                <tr key={l.id} className="border-b border-[var(--color-border)]/50">
                  <td className="py-2 pr-4 whitespace-nowrap">{new Date(l.created_at).toLocaleString("en-US")}</td>
                  <td className="py-2 pr-4">{l.user_name || "—"}</td>
                  <td className="py-2 pr-4"><span className="badge-info text-[10px]">{l.action}</span></td>
                  <td className="py-2 pr-4 text-xs">{l.entity_type}</td>
                  <td className="py-2">{l.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
